import React, { useContext } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import _ from "lodash";
import { getSchoolNameFromGame } from "games/utils";
import { makeStyles } from "@material-ui/core/styles";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import cc from "classcat";

const useStyles = makeStyles({
  table: {
    marginBottom: "20px",
    border: "1px solid black"
  },
  tableSticky: {
    position: "sticky",
    zIndex: "100",
    top: "0"
  },
  tableHead: {
    fontWeight: "bold"
  }
});

const Scoreboard = ({ currentTab }) => {
  const classes = useStyles();
  const {
    usePlayByPlay: [state]
  } = useContext(PlayByPlayContext);
  const { stats, game } = state;

  const tableClasses = cc([
    classes.table,
    { [classes.tableSticky]: currentTab === 0 }
  ]);

  const pointsSide = (side) => {
    const teamPointsSide = _.get(stats, [side, "teamStats"]);
    if (!teamPointsSide) return;
    const {
      totalPoints,
      firstQuarterPoints,
      secondQuarterPoints,
      thirdQuarterPoints,
      fourthQuarterPoints,
      overtimePoints,
      overtime2Points,
      overtime3Points
    } = teamPointsSide;

    return (
      <TableRow>
        <TableCell component="th" scope="row">
          {getSchoolNameFromGame(game, side)}
        </TableCell>
        <TableCell align="right">{firstQuarterPoints}</TableCell>
        <TableCell align="right">{secondQuarterPoints}</TableCell>
        <TableCell align="right">{thirdQuarterPoints}</TableCell>
        <TableCell align="right">{fourthQuarterPoints}</TableCell>
        <TableCell align="right">{overtimePoints}</TableCell>
        <TableCell align="right">{overtime2Points}</TableCell>
        <TableCell align="right">{overtime3Points}</TableCell>
        <TableCell align="right">{totalPoints}</TableCell>
      </TableRow>
    );
  };

  return (
    <TableContainer component={Paper} className={tableClasses}>
      <Table size="small" aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHead}>Team</TableCell>
            <TableCell align="right" className={classes.tableHead}>
              1
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              2
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              3
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              4
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              O1
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              O2
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              O3
            </TableCell>
            <TableCell align="right" className={classes.tableHead}>
              Total
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pointsSide("away")}
          {pointsSide("home")}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Scoreboard;
